var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"},on:{"enter":_vm.enter}},[(_vm.text)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"v-tooltip",style:(_vm.calculate)},[_c('span',{ref:"tip",class:[_vm.position, _vm.size],domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }